import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/tasks/{id}/confirm").POST();

export async function confirmTask({
    params,
    req,
}: {
    params: typeof endpoint.types.P;
    req: typeof endpoint.types.Req;
}) {
    const call = createCall(endpoint, (r) => fetch(withAccountAuthHeaders(r)));
    const res = await call({ params, req });

    return res;
}
